export const routes = [
  {
    path: '/grower-management',
    permission: 'MANAGE_GROWERS',
    component: 'GrowerManagement',
  },
  {
    path: '/operation-management',
    permission: 'MANAGE_OPERATIONS',
    component: 'OperationManagement',
  },
  {
    path: '/organization-management',
    permission: 'MANAGE_GROWERS',
    component: 'OrganizationManagement',
  },
  {
    path: '/user-management/:growergroup?',
    permission: 'MANAGE_USERS',
    component: 'UserManagement',
  },
  {
    path: '/admin/*',
    component: 'AdminDashboard',
  },
  {
    path: '/fieldboundaryupload/:growerid?',
    name: 'Field Boundary Upload',
    permission: 'MANAGE_FIELDS',
    group: 'boundary',
    component: 'FieldBoundaryUpload',
  },
  {
    path: '/field-boundary-management/:growerid?',
    name: 'Field Boundary Management',
    permission: 'VIEW_FIELDS',
    group: 'boundary',
    component: 'FieldBoundaryManagement',
  },
  {
    path: '/soil-upload/:growerid?',
    name: 'Soil Upload',
    permission: 'ADMIN_SOIL',
    group: 'soil',
    component: 'SoilCsvUpload',
  },
  {
    path: '/soil-report/:growerid?/:aaid?',
    name: 'Soil Report',
    permission: 'VIEW_SOIL',
    group: 'soil',
    component: 'SoilReport',
  },
  {
    path: '/soil-pending-fields',
    name: 'Soil Pending Fields',
    permission: 'ADMIN_SOIL',
    group: 'soil',
    excludeGrower: true,
    component: 'PendingFields',
  },
  {
    path: '/soil-sample-order/:growerid?',
    name: 'Soil Sample Order',
    permission: 'ORDER_SOIL',
    group: 'soil',
    component: 'SoilSampleOrderPage',
  },
  {
    path: '/soil-sample-order-dashboard',
    name: 'Soil Sample Dashboard',
    group: 'soil',
    permission: 'ORDER_SOIL',
    notPermission: 'ADMIN_SOIL',
    excludeGrower: true,
    component: 'SoilSampleOrderDashboardPage',
  },
  {
    path: '/soil-sample-order-admin',
    name: 'Soil Sample Dashboard',
    group: 'soil',
    permission: 'ADMIN_SOIL',
    excludeGrower: true,
    component: 'SoilSampleOrderAdminPage',
  },
  {
    path: '/soil-sample-internal-dashboard',
    name: 'Internal Sampling Dashboard',
    group: 'soil',
    permission: 'SAMPLE_SOIL',
    excludeGrower: true,
    component: 'SoilSamplingInternalDashboard',
    subHeaderComponent: 'DashboardSubHeader',
  },
  {
    path: '/planting-upload/:growerid?',
    name: 'Planting Upload',
    permission: 'MANAGE_PLANTING',
    group: 'plant',
    component: 'PlantingUpload',
  },
  {
    path: '/planting/:growerid?/:aaid?',
    name: 'Planting Display',
    permission: 'VIEW_PLANTING',
    group: 'plant',
    component: 'Planting',
  },
  {
    path: '/yield-upload/:growerid?',
    name: 'Yield Upload',
    permission: 'MANAGE_YIELD',
    group: 'yield',
    component: 'YieldUpload',
  },
  {
    path: '/yield-display/:growerid?/:aaid?',
    name: 'Yield Display',
    permission: 'VIEW_YIELD',
    group: 'yield',
    growerRequired: true,
    component: 'GrowerYield',
  },
  {
    path: '/potential-productivity/:growerid?/:aaid?',
    name: 'Potential Productivity',
    permission: 'VIEW_PRODUCTIVITY',
    group: 'rx',
    component: 'PotentialProductivity',
  },
  {
    path: '/nrx/:growerid?/:aaid?',
    name: 'N Rx',
    permission: 'VIEW_VR_N_RX',
    group: 'rx',
    component: 'Nrx',
  },
  {
    path: '/cornrx/:growerid?/:spacing?/:aaid?',
    name: 'Corn Rx',
    permission: 'VIEW_CORN_RX',
    group: 'rx',
    component: 'CornRXPage',
  },
  {
    path: '/soyrx/:growerid?/:aaid?',
    name: 'Soy Rx',
    permission: 'VIEW_SOY_RX',
    group: 'rx',
    component: 'SoyRXPage',
  },
  {
    path: '/lpk/:growerid?/:aaid?',
    name: 'LPK Rx',
    permission: 'VIEW_SOIL_FERTILITY_SUITE',
    group: 'rx',
    component: 'Lpk',
  },
  {
    path: '/n-protectant/:growerid?/:aaid?',
    name: 'N Protectant',
    permission: 'VIEW_N_PROTECTANT_RX',
    group: 'rx',
    component: 'NProtectant',
  },
  {
    path: '/early-season-fungicide/:growerid?/:aaid?',
    name: 'Early Season Fungicide',
    permission: 'VIEW_FUNGICIDE_SUITE',
    group: 'rx',
    component: 'EarlySeasonFungicide',
  },
  {
    path: '/starter-fertilizer/:growerid?',
    name: 'Starter Fertilizer',
    group: 'rx',
    permission: 'VIEW_STARTER',
    component: 'StarterFertilizerPage',
  },
  {
    path: '/eoy-report/:growerid?',
    name: 'Enterprise Report',
    permission: 'VIEW_ENTERPRISE_REPORT',
    group: 'eoy',
    component: 'EoyReport',
  },
  {
    path: '/field-agrilytics/:growerid?',
    name: 'Field Agrilytics',
    permission: 'VIEW_FIELD_AGRILYTICS',
    group: 'agrilytics',
    component: 'FieldAgrilytics',
  },
  {
    path: '/deere/:growerid?/*',
    name: 'John Deere Operations Center',
    permission: ['VIEW_OEM', 'MANAGE_OEM'],
    group: 'oem',
    component: 'Deere',
  },
  {
    path: '/signal/:growerid?',
    name: 'Signal',
    permission: 'VIEW_SIGNAL',
    featureFlag: 'Signal',
    group: 'signal',
    component: 'Signal',
  },
];
